module.exports = __webpack_public_path__ + "img/zhengfu.bb16b708.png";